import { render, staticRenderFns } from "./TrustDashboard.vue?vue&type=template&id=88aa76cc&scoped=true"
import script from "./TrustDashboard.vue?vue&type=script&lang=js"
export * from "./TrustDashboard.vue?vue&type=script&lang=js"
import style0 from "./TrustDashboard.vue?vue&type=style&index=0&id=88aa76cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88aa76cc",
  null
  
)

export default component.exports